


























































import Component from 'vue-class-component';
import ChargingOption from './charging-option.vue';
import SubHeadline from '../sub-headline/sub-headline.vue';
import ChargingOptionsGridEq from './charging-options-grid.vue';
import ChargingOptionsGridFunctions from './charging-options-grid-functions.vue';
import { ChargingOption as ChargingOptionInterface } from '../../store/modules/charging-data.interface';

@Component({
  name: 'eqweb-charging-options-grid-usa',
  components: { ChargingOption, SubHeadline, ChargingOptionsGridEq },
})
export default class ChargingOptionsGridUsa extends ChargingOptionsGridFunctions {
  protected getMq3Cols(chargingOptions: ChargingOptionInterface[]): number {
    let numberOfOptions = chargingOptions.length;
    if (
      this.getChargingOptions(this.batteryChangingInformationSeparated.public).length > 0 &&
      this.getChargingOptions(this.batteryChangingInformationSeparated.home).length > 0
    ) {
      const higherNumberOfOptions = Math.max(
        this.getChargingOptions(this.batteryChangingInformationSeparated.public).length,
        this.getChargingOptions(this.batteryChangingInformationSeparated.home).length,
      );
      numberOfOptions = higherNumberOfOptions;
    }
    return numberOfOptions > 4 ? 4 : 12 / numberOfOptions;
  }
}
